/** A single Genesys Cloud region entry from public/config.json. */
export interface RegionConfig {
  /** Genesys Cloud region key (e.g. "us_west_2"). */
  key: string;
  /** Human-readable label shown in the region selector dropdown. */
  label: string;
  /** OAuth Implicit Grant client ID registered in this region. */
  clientId: string;
  /** Genesys Cloud login base URI (e.g. "https://login.usw2.pure.cloud"). */
  loginBaseUri: string;
}

export interface IAppConfig {
  regions: RegionConfig[];
}

export class AppConfig implements IAppConfig {
  regions: RegionConfig[] = [];

  initialize = async (): Promise<void> => {
    const res = await fetch('/config.json');
    if (!res.ok) {
      throw new Error(`Failed to load config.json: ${res.status} ${res.statusText}`);
    }
    const config = (await res.json()) as IAppConfig;
    if (!config.regions || config.regions.length === 0) {
      throw new Error('config.json is missing required field: regions (must be a non-empty array)');
    }
    this.regions = config.regions;
  };
}

/** sessionStorage key for the user-selected region details. */
export const SESSION_KEY_REGION = 'gc_selected_region';

/** Shape stored in sessionStorage under SESSION_KEY_REGION. */
export interface StoredRegion {
  key: string;
  label: string;
  loginBaseUri: string;
  clientId: string;
}
